export const LEGAL_CONTRACTUAL_INFORMATION: string = `

### <!--= ++sectionIndex -->. Vertragsinformationen

Diese Servicebedingungen stellen eine Vereinbarung zwischen Ihnen und uns dar. Die folgenden Informationen identifizieren die Parteien dieser Vereinbarung:

<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

Telefon: Auf Anfrage
E-Mail: <!--= company.mail -->

Geschäftsführer
<!-- for (const director of company.directors) { -->
<!--= director -->
<!-- } -->

Registergericht: <!--= company.court -->
Registernummer: <!--= company.courtNumber -->

Umsatzsteuer-Identifikationsnummer (USt-ID): <!--= company.vat -->

Fragen zu diesen Bedingungen sollten uns per E-Mail zugesandt werden.
`;
